import { render, staticRenderFns } from "./TreeWeatherCanvas.vue?vue&type=template&id=84b27fb2&scoped=true&"
import script from "./TreeWeatherCanvas.vue?vue&type=script&lang=ts&"
export * from "./TreeWeatherCanvas.vue?vue&type=script&lang=ts&"
import style0 from "./TreeWeatherCanvas.vue?vue&type=style&index=0&id=84b27fb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b27fb2",
  null
  
)

export default component.exports